const isDevMode = /localhost|csp-dev.campaignregistry.com/.test(
  window.location.hostname
);

export const checkDisplayStatus = (status: string) => {
  const baseStatuses = ['review', 'published'];
  const devStatuses = isDevMode ? [...baseStatuses, 'draft'] : baseStatuses;
  return devStatuses.includes(status);
};
